export * from "./fetch";
import { useAPI } from "../../utils/use-api";
import { Endpoint } from "../common/endpoints";
import { useInfiniteAPI, } from "../../utils/use-infinite-api";
import { useMutation } from "../../utils/use-mutation";
import { creditorCreate, creditorUpdate, creditorCloseAccount, creditorChangeFlexiblePayoutSettings, creditorRequestFlexiblePayoutOverride, creditorClearFlexiblePayoutOverride, creditorUpdateHoldingPeriod, creditorUpdateMerchantCategoryCode, } from "./fetch";
export const useCreditorCreate = (params) => {
    return useMutation(creditorCreate, params);
};
export const useCreditorList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.CreditorList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useInfiniteCreditorList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useInfiniteAPI({
        endpoint: Endpoint.CreditorList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useCreditorSelf = (creditorId, queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.CreditorSelf,
        endpointParams: { creditorId },
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useCreditorUpdate = (creditorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return creditorUpdate(creditorId, body, queryParams, headers);
    }, params);
};
export const useCreditorCloseAccount = (creditorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return creditorCloseAccount(creditorId, body, queryParams, headers);
    }, params);
};
export const useCreditorChangeFlexiblePayoutSettings = (creditorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return creditorChangeFlexiblePayoutSettings(creditorId, body, queryParams, headers);
    }, params);
};
export const useCreditorRequestFlexiblePayoutOverride = (creditorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return creditorRequestFlexiblePayoutOverride(creditorId, body, queryParams, headers);
    }, params);
};
export const useCreditorClearFlexiblePayoutOverride = (creditorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return creditorClearFlexiblePayoutOverride(creditorId, body, queryParams, headers);
    }, params);
};
export const useCreditorUpdateHoldingPeriod = (creditorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return creditorUpdateHoldingPeriod(creditorId, body, queryParams, headers);
    }, params);
};
export const useCreditorUpdateMerchantCategoryCode = (creditorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return creditorUpdateMerchantCategoryCode(creditorId, body, queryParams, headers);
    }, params);
};
